import VisaCardIcon from '../../../assets/images/card-icons/Visa.png';
import defaultIcon from '../../../assets/images/card-icons/default-card-icon.png';

export default {
    Visa: VisaCardIcon,
    default: defaultIcon
}